<div *ngIf="RoleId=='1' || RoleId=='2'" class="col-md-6">
    <div class="panel with-nav-tabs panel-default">
        <div class="panel-heading">
            <ul class="nav nav-tabs ">
                <li [class.active]="tabSelected === 'rules'" id="home" (click)="onSelect('rules')">
                    <a data-toggle="tab">
                        <b style="font-size:17px;" class="">Rules</b></a>
                </li>
                <li [class.active]="tabSelected === 'exceptions'" id="menu1" (click)="onSelect('exceptions')">
                    <a data-toggle="tab">
                        <b style="font-size:17px;">Exceptions</b></a>
                </li>
            </ul>
        </div>
        <div class="panel-body">
            <div class="tab-content" style="padding-left:15px;">
                <app-rules *ngIf="tabSelected === 'rules'"></app-rules>
                <app-exceptions *ngIf="tabSelected === 'exceptions'"></app-exceptions>
            </div>
        </div>
    </div>
</div>